import React from 'react';
import aboutImg from '../../images/women-tek.png';
import '../../styles/about.css';

const chooseData = [
    {
        icon: 'ri-store-line',
        title: 'market segmentations',
        desc: 'Public area defense, Settlements/Facilities defense, Complexes/condominiums defense.'
    }, 
    {
        icon: 'ri-newspaper-line',
        title: 'functional Uniqueness',
        desc: 'Our product is designed for short-range detection of small objects and cardboard drones. It offers a highly affordable, compact solution with exceptional accuracy and sensitivity to even the slightest movements of small metallic objects. The system includes an intuitive application and can be seamlessly integrated with other defense systems.'
    }, 
    {
        icon: 'ri-graduation-cap-line',
        title: 'About the quantum gradiometer',
        desc: [
            'A quantum magnetometer is an advanced device used for measuring magnetic fields with extremely high precision, leveraging the principles of quantum mechanics.',
            'It typically operates by detecting changes in the quantum states of atoms or molecules caused by the external magnetic field.',
            'Atomic magnetometers are quantum devices making use of the fact that the electron spin of each atom in the gas reacts to its own magnetic field environment.',
            'Based on concepts: Atomic magnetometers, Spatial quantization and Spinning of electron.'
        ]
    }, 
];

export default function Selution1() {
    return (
        <section id='FirstSelution'>
            <div className="container selusion1">
                <div className="about_wrapper">
                    <div className="about_content">
                        <h6 className="subtitle">First Selution</h6>
                        <h2 className='subtitle_two'>First line of defense</h2>
                        <div className='choose_item-wrapper'>
                            {
                                chooseData.map((item, index) => (
                                    <div className="choose_us-item" key={index}>
                                        <span className="selution-icon"><i className={item.icon} /></span>
                                        <div>
                                            <h4 className="choose_us-title">{item.title}</h4>
                                            {
                                                Array.isArray(item.desc) ? (
                                                    <ul className="description" style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                                        {item.desc.map((point, idx) => <li key={idx}>{point}</li>)}
                                                    </ul>
                                                ) : (
                                                    <p className="description">{item.desc}</p>
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="aadd_img"><img src={aboutImg} alt="" /></div>
                </div>
            </div>
        </section>
    );
}
